import { getToApi, postToApi } from './axios';

// API wrappers para imágenes de atributos de nodos de componente.
// Patrón calcado de api/coleccionItemImage.js: presigned PUT directo a S3,
// confirm persiste la key, url devuelve presigned GET.

/**
 * Pide al backend una URL presigned PUT para subir una imagen de atributo a S3.
 * @param {number|string} equipoId
 * @param {number|string} nodeId
 * @param {string} attrKey — clave del atributo image
 * @param {'image/jpeg'|'image/png'|'image/webp'} contentType
 * @returns {Promise<{ uploadUrl: string, key: string }>}
 */
export const presignComponentAttrImageUpload = async (equipoId, nodeId, attrKey, contentType) => {
  const response = await postToApi(
    `/ascensores/${equipoId}/components/${nodeId}/attr-image/presign-upload`,
    { attrKey, contentType }
  );
  const data = response.data || response;
  if (data.state !== 'success') {
    throw new Error(data.message || 'Error generando presigned URL');
  }
  return {
    uploadUrl: data.uploadUrl,
    key: data.key,
  };
};

/**
 * Confirma el upload: persiste attributes[attrKey] = key.
 * @param {number|string} equipoId
 * @param {number|string} nodeId
 * @param {string} attrKey
 * @param {string} key — la key devuelta por presign-upload
 * @returns {Promise<void>}
 */
export const confirmComponentAttrImage = async (equipoId, nodeId, attrKey, key) => {
  const response = await postToApi(
    `/ascensores/${equipoId}/components/${nodeId}/attr-image/confirm`,
    { attrKey, key }
  );
  const data = response.data || response;
  if (data.state !== 'success') {
    throw new Error(data.message || 'Error confirmando la imagen');
  }
};

/**
 * Obtiene una URL presigned GET (1h) para mostrar la imagen de un atributo.
 * @param {number|string} equipoId
 * @param {number|string} nodeId
 * @param {string} attrKey
 * @returns {Promise<{ url: string }>}
 */
export const getComponentAttrImageUrl = async (equipoId, nodeId, attrKey) => {
  const data = await getToApi(
    `/ascensores/${equipoId}/components/${nodeId}/attr-image/url?attrKey=${encodeURIComponent(
      attrKey
    )}`
  );
  if (data.state !== 'success') {
    throw new Error(data.message || 'Error obteniendo URL de imagen');
  }
  return { url: data.url };
};
